import { useLayoutEffect } from "react"

import { GROUP } from "@shared/config"
import { useAccount } from "@shared/contexts"
import { isDev, isLocal, kick, removeTokens } from "@shared/modules"

export const useValidation = () => {
  const { account } = useAccount()

  useLayoutEffect(() => {
    if (isLocal || isDev) return
    if (!account.viewer) return

    const username = account.viewer.username
    if (username === "irwin-admin" || username === "arto-admin") return

    if (GROUP.STREAMER.includes(account.viewer.role)) return
    removeTokens()
    kick("허용되지 않은 권한 입니다.")
  }, [account.viewer])
}
